export const logpFAQProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "question", isLookup: false, lookupListProperty: [""] },
  { name: "answer", isLookup: false, lookupListProperty: [""] },
  { name: "active", isLookup: false, lookupListProperty: [""] },
  { name: "FAQTitle", isLookup: false, lookupListProperty: [""] },
  { name: "reference", isLookup: false, lookupListProperty: [""] },
  { name: "public", isLookup: false, lookupListProperty: [""] },
  { name: "Created", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "isDraft", isLookup: false, lookupListProperty: [""] },
  { name: "Author", isLookup: true, lookupListProperty: ["Id", "Title"] },
  { name: "verifiedDate", isLookup: false, lookupListProperty: [""] },

  {
    name: "section",
    isLookup: true,
    lookupListProperty: ["sectionTitle", "ID", "sectionType"]
  },
  {
    name: "questionType",
    isLookup: true,
    lookupListProperty: ["questionTitle", "ID"]
  },
  {
    name: "clientTypes",
    isLookup: true,
    lookupListProperty: ["clientTypeTitle", "ID"]
  }
];

export const guestFAQProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "question", isLookup: false, lookupListProperty: [""] },
  { name: "answer", isLookup: false, lookupListProperty: [""] },
  { name: "active", isLookup: false, lookupListProperty: [""] },
  { name: "FAQTitle", isLookup: false, lookupListProperty: [""] },
  { name: "reference", isLookup: false, lookupListProperty: [""] },
  { name: "public", isLookup: false, lookupListProperty: [""] },
  { name: "Created", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "isDraft", isLookup: false, lookupListProperty: [""] },
  { name: "verifiedDate", isLookup: false, lookupListProperty: [""] },

  // { name: "Author", isLookup: true, lookupListProperty: ["Id", "Title"] },

  { name: "sectionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "questionTypeTitle", isLookup: false, lookupListProperty: [""] },
  { name: "clientTypesTitle", isLookup: false, lookupListProperty: [""] },
  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const logpFAQFileProperties = [
  { name: "belongsToFAQ", isLookup: true, lookupListProperty: ["ID"] },
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Title", isLookup: false, lookupListProperty: [""] }
];

export const guestFAQFileProperties = [
  { name: "belongsToFAQ", isLookup: false, lookupListProperty: [""] },
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Title", isLookup: false, lookupListProperty: [""] },
  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const logpCombinationProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },

  {
    name: "section",
    isLookup: true,
    lookupListProperty: ["ID", "sectionTitle", "sectionType"]
  },
  {
    name: "clientType",
    isLookup: true,
    lookupListProperty: ["ID", "clientTypeTitle"]
  },
  {
    name: "questionType",
    isLookup: true,
    lookupListProperty: ["ID", "questionTitle"]
  }
];

export const guestCombinationProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },

  { name: "sectionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "questionTypeTitle", isLookup: false, lookupListProperty: [""] },
  { name: "clientTypeTitle", isLookup: false, lookupListProperty: [""] },
  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const currentUserProperties = [
  { name: "Id", isLookup: false, lookupListProperty: [""] },
  { name: "Title", isLookup: false, lookupListProperty: [""] },
  { name: "Email", isLookup: false, lookupListProperty: [""] },
  { name: "IsSiteAdmin", isLookup: false, lookupListProperty: [""] }
];

export const logpSectionProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "active", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "sectionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "sectionType", isLookup: false, lookupListProperty: [""] },

  {
    name: "connectedSections",
    isLookup: true,
    lookupListProperty: ["ID", "sectionTitle"]
  }
];

export const guestSectionProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "active", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "sectionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "sectionType", isLookup: false, lookupListProperty: [""] },

  {
    name: "connectedSectionsTitles",
    isLookup: false,
    lookupListProperty: [""]
  },
  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const logpQuestionTypeProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "questionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "questionDescription", isLookup: false, lookupListProperty: [""] },
  { name: "questionTemplate", isLookup: false, lookupListProperty: [""] }
];

export const guestQuestionTypeProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "questionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "questionDescription", isLookup: false, lookupListProperty: [""] },
  { name: "questionTemplate", isLookup: false, lookupListProperty: [""] },

  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const logpClientTypeProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "clientTypeTitle", isLookup: false, lookupListProperty: [""] }
];

export const guestClientTypeProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "clientTypeTitle", isLookup: false, lookupListProperty: [""] },

  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const logpKeywordProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "keyword", isLookup: false, lookupListProperty: [""] },

  {
    name: "section",
    isLookup: true,
    lookupListProperty: ["ID", "sectionTitle"]
  }
];

export const guestKeywordProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "keyword", isLookup: false, lookupListProperty: [""] },

  { name: "sectionTitle", isLookup: false, lookupListProperty: [""] },
  { name: "vsdlId", isLookup: false, lookupListProperty: [""] }
];

export const guestImportDateProperties = [
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "date", isLookup: false, lookupListProperty: [""] }
];

export const matterProperties = [
  { name: "matterTitle", isLookup: false, lookupListProperty: [""] },
  { name: "ID", isLookup: false, lookupListProperty: [""] },
  { name: "matterId", isLookup: false, lookupListProperty: [""] },
  { name: "matterDescription", isLookup: false, lookupListProperty: [""] },
  { name: "clientName", isLookup: false, lookupListProperty: [""] },
  { name: "clientMail", isLookup: false, lookupListProperty: [""] },
  { name: "clientPhone", isLookup: false, lookupListProperty: [""] },
  { name: "clientMisc", isLookup: false, lookupListProperty: [""] },
  { name: "matterResponse", isLookup: false, lookupListProperty: [""] },
  { name: "remindedUsers", isLookup: true, lookupListProperty: ["Id"] },
  { name: "recievedVia", isLookup: false, lookupListProperty: [""] },
  { name: "csCommentDraft", isLookup: false, lookupListProperty: [""] },
  {
    name: "checkedOutByUser",
    isLookup: true,
    lookupListProperty: ["Title", "Id", "EMail"]
  },
  {
    name: "answeredByUser",
    isLookup: true,
    lookupListProperty: ["Title", "Id", "EMail"]
  },
  { name: "lastReminderSent", isLookup: false, lookupListProperty: [""] },
  { name: "escalated", isLookup: false, lookupListProperty: [""] },
  { name: "testMatter", isLookup: false, lookupListProperty: [""] },
  { name: "prioritisedMatter", isLookup: false, lookupListProperty: [""] },
  { name: "cc", isLookup: false, lookupListProperty: [""] },
  { name: "bcc", isLookup: false, lookupListProperty: [""] },
  { name: "checkedOutAndReminded", isLookup: false, lookupListProperty: [""] },
  { name: "includeSpecialistName", isLookup: false, lookupListProperty: [""] },
  { name: "journalizeMatter", isLookup: false, lookupListProperty: [""] },
  { name: "clientMailArrivalDate", isLookup: false, lookupListProperty: [""] },
  { name: "answerDeadline", isLookup: false, lookupListProperty: [""] },
  {
    name: "questionType",
    isLookup: true,
    lookupListProperty: ["ID", "questionTitle"]
  },
  {
    name: "clientType",
    isLookup: true,
    lookupListProperty: ["ID", "clientTypeTitle"]
  },
  { name: "closedDate", isLookup: false, lookupListProperty: [""] },
  { name: "modifiedDate", isLookup: false, lookupListProperty: [""] },
  { name: "createdDate", isLookup: false, lookupListProperty: [""] },
  {
    name: "currentlyAssignedToRole",
    isLookup: true,
    lookupListProperty: ["ID", "roleTitle", "roleType"]
  },
  {
    name: "answeredByRole",
    isLookup: true,
    lookupListProperty: ["ID", "roleTitle"]
  },
  {
    name: "createdByRole",
    isLookup: true,
    lookupListProperty: ["ID", "roleTitle"]
  },
  {
    name: "escalatedByRole",
    isLookup: true,
    lookupListProperty: ["ID", "roleTitle"]
  },
  {
    name: "section",
    isLookup: true,
    lookupListProperty: ["ID", "sectionTitle"]
  },
  { name: "Modified", isLookup: false, lookupListProperty: [""] },
  { name: "Created", isLookup: false, lookupListProperty: [""] },
  { name: "Author", isLookup: true, lookupListProperty: ["Id", "Title"] },
  { name: "status", isLookup: false, lookupListProperty: [""] },
  { name: "isInternal", isLookup: false, lookupListProperty: [""] },
  { name: "internalDueDate", isLookup: false, lookupListProperty: [""] },
  {
    name: "assignedByRole",
    isLookup: true,
    lookupListProperty: ["ID", "roleTitle"]
  },
  { name: "answeredWithFaq", isLookup: true, lookupListProperty: ["ID"] },
  { name: "imported", isLookup: false, lookupListProperty: [""] },
  { name: "processStep", isLookup: false, lookupListProperty: [""] },
  { name: "handlingTime", isLookup: false, lookupListProperty: [""] },
  { name: "reopened", isLookup: false, lookupListProperty: [""] }
];
